<form [formGroup]="form" (ngSubmit)="save()">
    <mat-form-field class="margin-right-small">
        <input matInput placeholder="Apellido" formControlName="LastName" required>
        <mat-error *ngIf="f.LastName.errors  && f.LastName.errors.required">
            Ingrese el apellido
        </mat-error>
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input matInput placeholder="Nombre" formControlName="FirstName">
        <mat-error *ngIf="f.FirstName.errors  && f.FirstName.errors.required">
            Ingrese el nombre
        </mat-error>
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input type="text" matInput placeholder="Sexo" formControlName="Sex" [matAutocomplete]="autSex">
        <mat-autocomplete #autSex="matAutocomplete" [displayWith]="filterCompleteSexFilter.displayFn">
            <mat-option *ngFor="let sex of filterCompleteSexFilterOptions | async" [value]="sex">
                {{sex.Name}}
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="f.Sex.errors && f.Sex.errors.validAutoCompleteSelect">
            Ingrese el sexo
        </mat-error>
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input type="number" matInput placeholder="Matrícula nacional" formControlName="NationalRegistration">
        <mat-error *ngIf="f.NationalRegistration.errors && f.NationalRegistration.errors.invalidOneRegistrationRequired">
            Ingrese al menos una matrícula
        </mat-error>
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input type="number" matInput placeholder="Matrícula provincial" formControlName="ProvincialRegistration">
        <mat-error *ngIf="f.ProvincialRegistration.errors && f.ProvincialRegistration.errors.invalidOneRegistrationRequired">
            Ingrese al menos una matrícula
        </mat-error>
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input type="number" matInput placeholder="Matrícula especialidad" formControlName="SpecialityRegistration">
        <mat-error *ngIf="f.SpecialityRegistration.errors && f.SpecialityRegistration.errors.invalidOneRegistrationRequired">
            Ingrese al menos una matrícula
        </mat-error>
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input type="text" matInput placeholder="Relevancia" formControlName="Relevance" [matAutocomplete]="autRelevance">
        <mat-autocomplete #autRelevance="matAutocomplete" [displayWith]="filterCompleteRelevanceReferringPhysicianFilter.displayFn">
            <mat-option *ngFor="let relevance of filterCompleteRelevanceReferringPhysicianOptions | async" [value]="relevance">
                {{relevance.Name}}
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="f.Relevance.errors && f.Relevance.errors.validAutoCompleteSelect">
            Ingrese la relevancia
        </mat-error>
    </mat-form-field>

    <mat-form-field class="margin-right-small">
        <mat-select placeholder="Especialidades" formControlName="Specialities" multiple>
            <mat-select-trigger>
                {{f.Specialities.value?.length > 0 ? f.Specialities.value[0].Name : ''}}
                <span *ngIf="f.Specialities.value?.length > 1" class="additional-selection">
                    (+{{f.Specialities.value.length - 1}} {{f.Specialities.value?.length === 2 ? 'otra' : 'otras'}})
                  </span>
            </mat-select-trigger>
            <mat-option *ngFor="let referringPhysicianSpecialityFilter of referringPhysicianSpecialityFilters" [value]="referringPhysicianSpecialityFilter">
                {{referringPhysicianSpecialityFilter.Name}}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="f.Specialities.errors && f.Specialities.errors.required">
            Seleccione una especialidad
        </mat-error>
    </mat-form-field>

    <mat-form-field class="margin-right-small">
        <input type="text" matInput placeholder="País" (input)="onCountryChange()" formControlName="Country" [matAutocomplete]="autCountry">
        <mat-autocomplete #autCountry="matAutocomplete" (optionSelected)="countrySelected($event.option.value)" [displayWith]="filterCompleteCountryFilter.displayFn">
            <mat-option *ngFor="let country of filterCompleteCountryFilterOptions | async" [value]="country">
                {{country.Name}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input type="text" matInput placeholder="Provincia" (input)="onProvinceChange()" formControlName="Province" [matAutocomplete]="autProvince">
        <mat-autocomplete #autProvince="matAutocomplete" (optionSelected)="provinceSelected($event.option.value)" [displayWith]="filterCompleteProvinceFilter.displayFn">
            <mat-option *ngFor="let province of filterCompleteProvinceFilterOptions | async" [value]="province">
                {{province.Name}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input type="text" matInput placeholder="Localidad" (input)="onLocalityChange($event.target.value)" formControlName="Locality" [matAutocomplete]="autLocality">
        <mat-autocomplete #autLocality="matAutocomplete" [displayWith]="filterCompleteLocalityFilter.displayFn">
            <mat-option *ngFor="let locality of filterCompleteLocalityFilterOptions | async" [value]="locality">
                {{locality.Name}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input matInput placeholder="Calle" formControlName="AddressStreet">
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input matInput placeholder="Nro" formControlName="AddressNumber">
    </mat-form-field>
      <mat-form-field class="margin-right-small">
        <input matInput placeholder="C.P." formControlName="AddressCP">
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input matInput placeholder="Piso" formControlName="Floor">
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input matInput placeholder="Depto." formControlName="AddressDpto">
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input matInput type="number" placeholder="Teléfono particular" formControlName="PersonalPhone">
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input matInput type="number" placeholder="Teléfono laboral" formControlName="LaborPhone">
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input matInput type="number" placeholder="Celular" formControlName="CellPhone">
        <mat-error *ngIf="f.CellPhone.errors && f.CellPhone.errors.invalidCellPhoneNumber">
            El número ingresado no es válido
        </mat-error>
        <mat-hint>ej: 11-1111-1111 (sin 15 al incio)</mat-hint>
    </mat-form-field>
    <mat-form-field class="margin-right-small">
        <input matInput placeholder="Email" formControlName="Email">
        <mat-error *ngIf="f.Email.errors && f.Email.errors.email">
            El mail ingresado no es válido
        </mat-error>
    </mat-form-field>
    <div class="clearfix">
        <div class="pull-right">
            <mat-spinner *ngIf="loadingAction" matSuffix [diameter]="20"></mat-spinner>
            <button *ngIf="!loadingAction" mat-button type="submit">Guardar</button>
            <button *ngIf="!loadingAction" mat-button type="button" (click)="close()" cdkFocusInitial>Salir</button>
        </div>
    </div>
</form>
